<div class="cf-dlg">

  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>file_download</mat-icon></div>
    <div>
      <h2 class="cf-dlg-title">Ver fichero</h2>
      <p class="cf-dlg-subtitle">{{ note }}</p>
    </div>
  </div>

  <div class="cf-dlg-footer">
    <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cerrar</button>
    <button mat-flat-button class="cf-dlg-btn-primary" (click)="downloadFile()">
      <mat-icon>open_in_new</mat-icon> Abrir fichero
    </button>
  </div>

</div>
